import { CapoPlugin } from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];